import { api } from "./client.js";

export type EntryType = "vacation" | "timeoff" | "medical" | "trip" | "nomadic";

export interface TravelEntry {
  id: string;
  city: string;
  country: string;
  country_code: string;
  timezone: string;
  latitude: number | null;
  longitude: number | null;
  date_from: string;
  date_to: string | null;
  entry_type: EntryType;
  notes: string | null;
}

export interface NewTravel {
  city: string;
  country: string;
  country_code: string;
  timezone: string;
  latitude?: number | null;
  longitude?: number | null;
  date_from: string;
  date_to?: string | null;
  entry_type: EntryType;
  notes?: string | null;
}

export const travelApi = {
  list: () => api.get<{ travel: TravelEntry[] }>("/api/travel"),
  create: (entry: NewTravel) => api.post<{ entry: TravelEntry }>("/api/travel", entry),
  update: (id: string, patch: Partial<NewTravel>) =>
    api.patch<{ entry: TravelEntry }>(`/api/travel/${id}`, patch),
  remove: (id: string) => api.del<{ deleted: boolean }>(`/api/travel/${id}`),
  // M6 B-slice: re-confirm a presence. With extendTo it stays current; without, it
  // just marks confirmed (so "I'm back" snaps the map home).
  confirm: (id: string, extendTo?: string) =>
    api.post<{ entry: TravelEntry }>(
      `/api/travel/${id}/confirm`,
      extendTo ? { extend_to: extendTo } : {},
    ),
};
